import { Text } from '../../../../components/dataDisplay';
import { Box } from '../../../../components/internal';
import { StatusIconSolid } from '../../../../foundations';
import { useBreakpoint } from '../../../../theme';
import { Group } from '../../../Group';
import { BaseModal } from '../../BaseModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StatusModalHeader = _ref => {
  var {
    variant,
    children,
    description
  } = _ref;
  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  return /*#__PURE__*/_jsx(BaseModal.Header, {
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      children: [/*#__PURE__*/_jsxs(Group, {
        variant: "vertical",
        alignItems: isMobile ? 'flex-start' : 'center',
        spacing: "m",
        width: "full",
        children: [/*#__PURE__*/_jsx(StatusIconSolid, {
          size: "extra-large",
          variant: variant,
          "aria-hidden": true
        }), children && /*#__PURE__*/_jsx(Box, {
          alignSelf: "flex-start",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h3",
            "data-testid": "modal-status-header",
            textStyle: "heading2Semi",
            children: children
          })
        })]
      }), description && /*#__PURE__*/_jsx(Text, {
        children: description
      })]
    })
  });
};
StatusModalHeader.displayName = 'StatusModalHeader';
//# sourceMappingURL=StatusModalHeader.js.map